App.Routers.TreatwellPay = Backbone.Router.extend({
  routes: {
    '': 'index',
    '*step': 'index',
  },

  index: function () {
    // Boot the venue on a cold/direct deep link (e.g. #review, #payment,
    // #order/<ref>) that no other router matches, so the Reconnect app still
    // mounts. The Header router's '' and 'venue/:id' routes are registered
    // later and so are matched first by Backbone.history; it stops at the
    // first match, so this catch-all only fires when they don't — never a
    // double boot on the empty hash or a venue route.
    //
    // Guard on App.config so this only boots a cold load, never re-boots an
    // already-mounted app: a later hashchange (manual URL edit, or Back across
    // the in-flow #review/#payment steps) re-runs Backbone's loadUrl and would
    // otherwise remount the app mid-checkout. Same idiom as photoshoot-router.
    if (App.config == null) {
      App.initVenue(null);
    }
  },
});
